import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/Spinner";

type StoreImageUploadDialogProps = {
  pendingImage: {
    file: File;
    type: "cover" | "logo";
    previewUrl: string;
  } | null;
  isPending: boolean;
  onCancel: () => void;
  onUpload: (file: File, type: "cover" | "logo") => void;
};

export function StoreImageUploadDialog({
  pendingImage,
  isPending,
  onCancel,
  onUpload,
}: StoreImageUploadDialogProps) {
  return (
    <Dialog
      open={!!pendingImage}
      onOpenChange={(open) => {
        if (!open) onCancel();
      }}
    >
      <DialogContent className="max-w-sm" onOpenAutoFocus={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle>
            {pendingImage?.type === "cover" ? "Update Cover Image" : "Update Logo"}
          </DialogTitle>
        </DialogHeader>

        {pendingImage &&
          (pendingImage.type === "cover" ? (
            <div className="aspect-video rounded-lg overflow-hidden bg-muted">
              <img
                src={pendingImage.previewUrl}
                alt="Preview"
                className="w-full h-full object-cover"
              />
            </div>
          ) : (
            <div className="flex justify-center py-2">
              <div className="w-54 h-54 rounded-lg overflow-hidden border-2 border-border">
                <img
                  src={pendingImage.previewUrl}
                  alt="Preview"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          ))}

        <DialogFooter>
          <Button variant="outline" onClick={onCancel} disabled={isPending}>
            Cancel
          </Button>
          <Button
            onClick={() => pendingImage && onUpload(pendingImage.file, pendingImage.type)}
            disabled={isPending}
          >
            {isPending ? <Spinner className="size-4 border-primary-foreground" /> : "Upload"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
